<script>
	import options from './SiteNavigationMegaMenu.options'
	export default options
</script>

<template >
	<transition
		name="nlx-site-navigation__mega-menu-content-fade"
		@before-enter="beforeEnter"
		@enter="enter"
		@leave="leave"
		>
		<section class="nlx-site-navigation__mega-menu-content" v-if="menuData" @mouseleave="hideMegaMenu">

			<div class="nlx-site-navigation__mega-menu-link-section">
				<ul class="nlx-site-navigation__mega-menu-link-list" :data-menu="menuData.displayName">
					<template v-for="(megaMenu,megaKey) in menuData.megaMenu" :key="megaKey">
						<li class="nlx-site-navigation__mega-menu-link-item">
							<ul class="nlx-site-navigation__mega-menu-category-list">

								<template v-for="(link,columnKey) in megaMenu" :key="columnKey">
									<li class="nlx-site-navigation__mega-menu-category-list-item">
										<template v-if="link.arrowLink">
											<a :href="link.href" class="nlx-site-navigation__link-arrow-type nlx-site-navigation__link-arrow-type--mega-menu">
												<span>{{link.displayName}}</span>
												<div class="nlx-site-navigation__arrow-icon-container">
													<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 26">
														<defs>
															<clipPath id="clip-Artboard_5">
															<rect width="60" height="26"/>
															</clipPath>
														</defs>
														<g id="Artboard_5" data-name="Artboard – 5" clip-path="url(#clip-Artboard_5)">
															<line id="Line_16" data-name="Line 16" x2="56" transform="translate(1.5 12.5)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
															<line id="Line_17" data-name="Line 17" x2="10.678" y2="10.678" transform="translate(46.822 1.822)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
															<line id="Line_18" data-name="Line 18" x2="10.678" y2="10.678" transform="translate(46.822 1.822)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
															<line id="Line_19" data-name="Line 19" y1="10.678" x2="10.678" transform="translate(46.822 12.822)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
														</g>
													</svg>
												</div>
											</a>
										</template>
										<template v-else>
											<a :href="link.href">{{link.displayName}}</a>
										</template>
									</li>
								</template>
								
							</ul>
						</li>
					</template>
				</ul>
			</div>

			<div class="nlx-site-navigation__mega-menu-product-focus-section">
				<template v-for="(spot,spotKey) in spotData" :key="spotKey">
					<article class="nlx-site-navigation__mega-menu-product-focus nlx-js--mega-menu-spot">
						<img class="nlx-site-navigation__mega-menu-product-focus-image" :src="spot.img.src" :alt="spot.img.alt"/>
						<p class="nlx-site-navigation__mega-menu-product-focus-title nlx-js--mega-menu-spot--title">{{spot.title}}</p>
						<a :href="spot.link.href" class="nlx-site-navigation__link-arrow-type nlx-site-navigation__link-arrow-type--spot-link nlx-js--mega-menu-spot--link">
								<span>{{spot.link.displayName}}</span>
								<div class="nlx-site-navigation__arrow-icon-container">
									<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 26">
										<defs>
											<clipPath id="clip-Artboard_5">
											<rect width="60" height="26"/>
											</clipPath>
										</defs>
										<g id="Artboard_5" data-name="Artboard5" clip-path="url(#clip-Artboard_5)">
											<line id="Line_16" data-name="Line 16" x2="56" transform="translate(1.5 12.5)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
											<line id="Line_17" data-name="Line 17" x2="10.678" y2="10.678" transform="translate(46.822 1.822)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
											<line id="Line_18" data-name="Line 18" x2="10.678" y2="10.678" transform="translate(46.822 1.822)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
											<line id="Line_19" data-name="Line 19" y1="10.678" x2="10.678" transform="translate(46.822 12.822)" fill="none" stroke="#1d1d1c" stroke-linecap="round" stroke-width="3"/>
										</g>
									</svg>
								</div>
							</a>
					</article>
				</template>
			</div>
		</section>
	</transition>
</template>
